export default "__VITE_ASSET__33618091__"